export default __webpack_public_path__ + "static/media/logo_min.7a27780a.png";